import classNames from 'classnames';
import { IconWithText } from 'common/icon/icon-with-text.js';
import { Tile } from 'common/tile/tile.js';
import { Fragment } from 'react';
import { IModule } from 'redux-state/layout/types.js';
import { LinkRef } from './condition/link-ref.js';
import { TileBodyHeaderV2 } from 'common/tile/tile-body-header-v2.js';

interface ISkiField {
  name: string;
  snowFall: number;
  lastSnowfall?: string; // ISO8601 string
}

interface IArea {
  label?: string;
  skiFields: ISkiField[];
}

interface ISnowForecast {
  areas: IArea[];
}

const SkiField = ({ skiField: { name, snowFall, lastSnowfall } }: { skiField: ISkiField }) => {
  /*
   * Due to limitations on the API number fields get to the frontend as strings,
   * hence the check below.
   */
  const hasSnowFall = snowFall || snowFall === 0;
  const lastSnowfallPrefix = hasSnowFall ? ' | ' : '';
  // name="snow-dark"
  return (
    <IconWithText classes="u-mT-sm svg-fill-textSlate" icon="snow">
      <h4 className="u-mT-0 u-mB-0">{name} ski field</h4>
      <p className="small u-mT-0 u-mB-0">
        {hasSnowFall && `${snowFall}cm`}
        {lastSnowfall && (
          <span>
            {lastSnowfallPrefix}Last snowfall: {lastSnowfall}
          </span>
        )}
      </p>
    </IconWithText>
  );
};

export const SnowForecast = (props: IModule<ISnowForecast>) => {
  const {
    config: { areas, link },
  } = props;

  const body = areas.map((area, index) => {
    const { label, skiFields } = area;

    return (
      <Fragment key={index}>
        {label && <h3 className={classNames({ 'u-mT-sm u-pT-sm u-bT-1': index !== 0 })}>{label}</h3>}

        {skiFields.map((skiField, index) => (
          <SkiField skiField={skiField} key={index} />
        ))}
      </Fragment>
    );
  });

  return (
    <Tile dataModule="snow-forecast" {...props}>
      <div className="Tile-body">
        <TileBodyHeaderV2 {...props} />
        {body}
        <LinkRef link={link} />
      </div>
    </Tile>
  );
};
